import CryptoJS from 'crypto-js';
import { uniqueDeviceId } from '../../api/http';

export const encryptData = (data: string, key: string) => {
  if (!key) throw new Error('encryptData: missing encryption key');
  return CryptoJS.AES.encrypt(data, key).toString();
};

export const decryptData = (data: string, key: string) => {
  if (!key) throw new Error('decryptData: missing encryption key');
  return CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8);
};

export const loginEncyptionKey = `${process.env.REACT_APP_LOGIN_ENCRYPTION_KEY}:${uniqueDeviceId}`;
